import { html } from "lit";

export const Template = () => {
    return html`
        <div class="ux-u-mb-fluid-s">
            <div class="ux-iws-marginal-column__headline ux-u-mb-xxs">
                <span class="ux-text-headline ux-text-headline--medium"
                    >Kontakt</span
                >
            </div>
            <div class="ux-text-headline ux-text-headline--small ux-u-mb-xxs">
                Sales Power Tools
            </div>
            <div class="ux-text-normal ux-u-mb-xxxs">
                <a href="tel:+41-58-257-61-44"> Telefon +41 58 257 61 44 </a>
            </div>
            <div class="ux-text-normal ux-u-mb-xxxs">Fax +41 58 257 64 01</div>
            <a
                class="ux-text-link ux-text-link--green"
                subject="title"
                body="HTTP_REFERER"
                href='mailto:powertools@ch.trumpf.com?subject=Anfrage über Website: "TruTool C 160"&amp;body=%0D%0ADiese Anfrage kam über die Seite https://srv01jira1/'
            >
                E-Mail
                <ux-icon name="arrow-small-right"></ux-icon>
            </a>
        </div>
        <div>
            <div class="ux-iws-marginal-column__headline ux-u-mb-xxs">
                <span class="ux-text-headline ux-text-headline--medium"
                    >Services</span
                >
            </div>
            <ux-iws-teaser-sidebar-icon>
                <ux-icon name="globe" slot="icon"></ux-icon>
                <span slot="title" class="ux-text-normal"> Finanzierung </span>
                <a
                    href="#"
                    class="ux-text-link ux-text-link--green"
                    slot="link"
                >
                    Discover more
                    <ux-icon name="arrow-small-right"></ux-icon>
                </a>
            </ux-iws-teaser-sidebar-icon>
            <ux-iws-teaser-sidebar-icon>
                <ux-icon name="crane" slot="icon"></ux-icon>
                <span slot="title" class="ux-text-normal"> Schulungen </span>
                <a
                    href="#"
                    class="ux-text-link ux-text-link--green"
                    slot="link"
                >
                    Discover more
                    <ux-icon name="arrow-small-right"></ux-icon>
                </a>
            </ux-iws-teaser-sidebar-icon>
            <ux-iws-teaser-sidebar-icon>
                <ux-icon name="machine-circle-arrows" slot="icon"></ux-icon>
                <span slot="title" class="ux-text-normal">
                    Gebrauchtmaschinen
                </span>
                <a
                    href="#"
                    class="ux-text-link ux-text-link--green"
                    slot="link"
                >
                    Discover more
                    <ux-icon name="arrow-small-right"></ux-icon>
                </a>
            </ux-iws-teaser-sidebar-icon>
            <ux-iws-teaser-sidebar-icon>
                <ux-icon name="document-checkmark" slot="icon"></ux-icon>
                <span slot="title" class="ux-text-normal">
                    Servicevereinbarungen
                </span>
                <a
                    href="#"
                    class="ux-text-link ux-text-link--green"
                    slot="link"
                >
                    Discover more
                    <ux-icon name="arrow-small-right"></ux-icon>
                </a>
            </ux-iws-teaser-sidebar-icon>
            <ux-iws-teaser-sidebar-icon>
                <ux-icon name="avatar-technical-service" slot="icon"></ux-icon>
                <span slot="title" class="ux-text-normal">
                    Technischer Kundendienst
                </span>
                <a
                    href="#"
                    class="ux-text-link ux-text-link--green"
                    slot="link"
                >
                    Discover more
                    <ux-icon name="arrow-small-right"></ux-icon>
                </a>
            </ux-iws-teaser-sidebar-icon>
        </div>
    `;
};
